<template>
    <div class="sub-footer">
      <main class="container">
      <div class="row">
        <div class="col-sm">
            <p class="hakcipta">© Hak Cipta 2022. Kementerian Keuangan Republik Indonesia.</p>
        </div>
        <div class="col-sm">
            <p class="kebijakan-privasi" @click="GAEventTrack('footer', 'click-footer', 'privasi')"><a href="/kebijakan-privasi" >Kebijakan Privasi</a></p>
        </div>
      </div>
      </main>
    </div>
</template>

<script>
import EventTracking from '../services/eventTracking'

export default {
    mixins: [EventTracking],
    name: 'SubFooter',
};
</script>